import { createContext, useContext, useState } from 'react';

interface ModalStateContextType {
  isContactModalOpen: boolean;
  isTourModalOpen: boolean;
  isMakeProposalModalOpen: boolean;
  isCheckoutPaymentOpen: boolean;
  isLoginSignupOpen: boolean;
  pendingAction: 'contact' | 'tour' | 'proposal' | null;
  openContactModal: () => void;
  closeContactModal: () => void;
  openTourModal: () => void;
  closeTourModal: () => void;
  openMakeProposalModal: () => void;
  closeMakeProposalModal: () => void;
  openCheckoutPayment: () => void;
  closeCheckoutPayment: () => void;
  openLoginSignup: () => void;
  closeLoginSignup: () => void;
  afterLoginAction: any;
  setAfterLoginAction: any;
  setPendingAction: (action: 'contact' | 'tour' | 'proposal' | null) => void;
}

export const ModalStateContext = createContext<ModalStateContextType>({
  isContactModalOpen: false,
  isTourModalOpen: false,
  isMakeProposalModalOpen: false,
  isCheckoutPaymentOpen: false,
  isLoginSignupOpen: false,
  openContactModal: () => {},
  closeContactModal: () => {},
  openTourModal: () => {},
  closeTourModal: () => {},
  openMakeProposalModal: () => {},
  closeMakeProposalModal: () => {},
  openCheckoutPayment: () => {},
  closeCheckoutPayment: () => {},
  openLoginSignup: () => {},
  closeLoginSignup: () => {},
  afterLoginAction: null,
  setAfterLoginAction: () => {},
  pendingAction: null,
  setPendingAction: () => {},
});

export const ModalStateProvider: React.FC = ({ children }: any) => {
  const [isContactModalOpen, setContactModalOpen] = useState(false);
  const [isTourModalOpen, setTourModalOpen] = useState(false);
  const [isMakeProposalModalOpen, setMakeProposalModalOpen] = useState(false);
  const [isCheckoutPaymentOpen, setCheckoutPaymentOpen] = useState(false);
  const [isLoginSignupOpen, setLoginSignupOpen] = useState(false);
  const [afterLoginAction, setAfterLoginAction] = useState<Function | null>(null);
  const [pendingAction, setPendingAction] = useState<'contact' | 'tour' | 'proposal' | null>(null);

  const openContactModal = () => setContactModalOpen(true);
  const closeContactModal = () => setContactModalOpen(false);
  const openTourModal = () => setTourModalOpen(true);
  const closeTourModal = () => setTourModalOpen(false);
  const openMakeProposalModal = () => setMakeProposalModalOpen(true);
  const closeMakeProposalModal = () => setMakeProposalModalOpen(false);
  const openCheckoutPayment = () => setCheckoutPaymentOpen(true);
  const closeCheckoutPayment = () => setCheckoutPaymentOpen(false);
  const openLoginSignup = () => setLoginSignupOpen(true);
  const closeLoginSignup = () => setLoginSignupOpen(false);

  return (
    <ModalStateContext.Provider
      value={{
        isContactModalOpen,
        isTourModalOpen,
        isMakeProposalModalOpen,
        isCheckoutPaymentOpen,
        isLoginSignupOpen,
        openContactModal,
        closeContactModal,
        openTourModal,
        closeTourModal,
        openMakeProposalModal,
        closeMakeProposalModal,
        openCheckoutPayment,
        closeCheckoutPayment,
        openLoginSignup,
        closeLoginSignup,
        afterLoginAction,
        setAfterLoginAction,
        pendingAction,
        setPendingAction,
      }}
    >
      {children}
    </ModalStateContext.Provider>
  );
};

export const useModalState = () => useContext(ModalStateContext);
